import React from "react";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container-heritage py-16 md:py-20 max-w-3xl mx-auto">

        {/* Heading */}
        <h1 className="font-serif text-3xl md:text-4xl font-medium text-foreground mb-4 text-center">
          Privacy Policy
        </h1>

        <p className="text-sm text-muted-foreground text-center mb-12">
          Last updated: {new Date().toLocaleDateString("en-IN")}
        </p>

        {/* Content */}
        <div className="space-y-8 text-sm leading-relaxed text-muted-foreground">

          <section>
            <h2 className="font-medium text-foreground mb-2">
              Introduction
            </h2>
            <p>
              Anand Fashion respects your privacy and is committed to protecting
              any personal information you share with us. This Privacy Policy
              explains how we collect, use, and safeguard your information when
              you visit our website.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-foreground mb-2">
              Information We Collect
            </h2>
            <p>
              We do not collect personal data automatically. Information is only
              collected when you voluntarily contact us through phone, WhatsApp,
              or enquiry forms. This may include your name, phone number, and
              enquiry details.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-foreground mb-2">
              How We Use Your Information
            </h2>
            <p>
              Any information you share with us is used solely to respond to your
              enquiries, provide requested information, and improve customer
              service. We do not sell, trade, or rent your personal information
              to third parties.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-foreground mb-2">
              Cookies & Tracking
            </h2>
            <p>
              This website does not use cookies or tracking tools for marketing
              or analytics purposes. We aim to provide a simple and transparent
              browsing experience.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-foreground mb-2">
              Third-Party Links
            </h2>
            <p>
              Our website may contain links to third-party platforms such as
              WhatsApp, Instagram, or Google Maps. We are not responsible for the
              privacy practices or content of these external websites.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-foreground mb-2">
              Data Security
            </h2>
            <p>
              We take reasonable measures to protect your information. However,
              please note that no method of transmission over the internet is
              completely secure.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-foreground mb-2">
              Changes to This Policy
            </h2>
            <p>
              Anand Fashion reserves the right to update this Privacy Policy at
              any time. Any changes will be reflected on this page.
            </p>
          </section>

          <section>
            <h2 className="font-medium text-foreground mb-2">
              Contact Us
            </h2>
            <p>
              If you have any questions regarding this Privacy Policy, you may
              contact us directly at our store in Udaipur, Rajasthan, or reach
              out via phone or WhatsApp.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default Privacy;
